import { module } from 'modujs';
import Swup from 'swup';
import SwupFadeTheme from '@swup/fade-theme';
import Channels from '../base/channels';
import Env from '../base/env';

export default class extends module {
  constructor(m) {
    super(m);
    this.events = {
      change: {
        trigger: 'update',
      },
    };
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.VARS = {
      BASE_URL: window.location.origin + window.location.pathname,
    };

    // Swup
    this.swupInstance = new Swup({
      animateHistoryBrowsing: true,
      linkSelector: '',
      containers: ['#swup-list'],
      plugins: [
        new SwupFadeTheme({
          mainElement: '#swup-list',
        }),
      ],
    });
    this.swupInstance.hooks.on('visit:start', () => {
      if (scrollInstance.scroll > 0) {
        scrollObjectInstance.scrollTo(0);
      }
    });
    this.swupInstance.hooks.on('visit:end', () => {
      Channels.emit('scroll::refresh');
    });
  }

  update() {
    const getFilter =
      this.$('trigger')[0].options[this.$('trigger')[0].selectedIndex].value;
    const requestURL = new URL(this.VARS.BASE_URL);
    requestURL.searchParams.append('sort_by', getFilter);
    this.swupInstance.navigate(requestURL.href);
  }
}
